import { INTERNAL_PATHS } from "routes/paths";
import desktopGetPaid from "assets/images/how-it-works/more-ways/desktop/get-paid.png";
import desktopNeverMiss from "assets/images/how-it-works/more-ways/desktop/never-miss.png";
import desktopReferFriends from "assets/images/how-it-works/more-ways/desktop/refer-friends.png";
import desktopSellGiftCards from "assets/images/how-it-works/more-ways/desktop/sell-gift-cards.png";
import mobileGetPaid from "assets/images/how-it-works/more-ways/mobile/get-paid.png";
import mobileNeverMiss from "assets/images/how-it-works/more-ways/mobile/never-miss.png";
import mobileReferFriends from "assets/images/how-it-works/more-ways/mobile/refer-friends.png";
import mobileSellGiftCards from "assets/images/how-it-works/more-ways/mobile/sell-gift-cards.png";

export const ACTIONS_MORE_WAYS_TO_USE = [
  {
    id: 1,
    imageDesktop: desktopGetPaid,
    imageMobile: mobileGetPaid,
    title: {
      line1: "Get Paid",
      line2: "to Gift"
    },
    description: {
      line1: "Earn up to 10% back in GCX",
      line2: "Cash when you send cash",
      line3: "back gift cards to friends",
      line4: "and family via email."
    },
    cta: "SEND A GIFT",
    linkTo: INTERNAL_PATHS.SHOP_CASHBACK
  },
  {
    id: 2,
    imageDesktop: desktopNeverMiss,
    imageMobile: mobileNeverMiss,
    title: {
      line1: "Never Miss",
      line2: "A Deal"
    },
    description: {
      line1: "Set brand alerts on gcx.raise.com",
      line2: "to track prices for your favorite",
      line3: "brands and get alerts sent",
      line4: "straight to your inbox."
    },
    cta: "SET AN ALERT",
    linkTo: INTERNAL_PATHS.BUY_GIFT_CARDS
  },
  {
    id: 3,
    imageDesktop: desktopSellGiftCards,
    imageMobile: mobileSellGiftCards,
    title: {
      line1: "Sell Gift Cards",
      line2: "for Cash"
    },
    description: {
      line1: "Got any unwanted gift cards lying",
      line2: "around? List them for sale on GCX",
      line3: "and get paid via ACH or PayPal",
      line4: "when they sell."
    },
    cta: "SELL A CARD",
    linkTo: INTERNAL_PATHS.SELL_GIFT_CARDS
  },
  {
    id: 4,
    imageDesktop: desktopReferFriends,
    imageMobile: mobileReferFriends,
    title: {
      line1: "Refer Friends & Get",
      line2: "Rewarded"
    },
    description: {
      line1: "Invite your friends to join GCX!",
      line2: "We’ll give you and your friends $5",
      line3: "in GCX Cash when they make",
      line4: "their first purchase."
    },
    cta: "REFER A FRIEND",
    linkTo: INTERNAL_PATHS.REFERRAL_PROGRAM
  }
];
